// The few BaseLayer.js values that pages outside the map need (the landing page,
// account pages, place search). They live here so importing them doesn't pull
// BaseLayer.js, and the map code it brings, into those pages' bundle.

// Where the site lives on its domain: "/uk", from "homepage" in package.json (CRA's
// PUBLIC_URL, the same in npm start and npm run build). Each country gets its own app
// at its own path. Prefix it to any link that isn't a router <Link> or navigate(), which
// add it themselves (BrowserRouter's basename in index.js).
export const APP_PATH = process.env.PUBLIC_URL || '';

// The servlets, same origin under APP_PATH. REACT_APP_BASE_URL (empty in .env.production
// and .env.local) can point a dev bundle at another server instead.
export const baseUrl = process.env.REACT_APP_BASE_URL || APP_PATH;

// The Big Picture's whole-country maps - the keys of AREA_MAPS (areaMaps.js), listed
// here rather than imported, so this file stays free of the map definitions. Keep it free of
// OpenLayers too (HIDDEN_STYLE lives in hiddenStyle.js): the landing page imports it
export const areaMapLayers = ['propertyLad', 'crimeLad', 'deprivationLad', 'rentLad', 'salesRateLad', 'connectivityLad', 'migrationLad', 'imdLad'];
// The Big Picture's layers: shown without a place picked, one at a time
export const listLayers = ['priceChangeList'].concat(areaMapLayers);

